import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeLanguage } from '../redux/slices/languageSlice'
import { Menu, MenuItem, Typography, Stack } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const LanguageSelector = () => {
  const dispatch = useDispatch()
  const selectedLanguage = useSelector(({ language }) => language.value)
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleMenuOpen = e => {
    setAnchorEl(e.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleLanguageChange = value => {
    dispatch(changeLanguage(value))
    handleMenuClose()
  }

  return (
    <Stack
      display="inline-grid"
      justifyContent="flex-start"
    >
      <Stack
        display="inline-grid"
        gap={1}
        gridAutoFlow="column"
        justifyContent="flex-start"
        alignItems="center"
        alignContent="center"
        sx={{ cursor: 'pointer' }}
        onClick={handleMenuOpen}
      >
        <Typography
          variant="button"  
        >
          {selectedLanguage === 'es' ? 'Español' : 'English'}
        </Typography>
        <ExpandMoreIcon
          sx={theme => ({
            transform: open ? 'rotate(-180deg)' : 'rotate(0)',
            transition: theme.transitions.create(['transform']),
          })}
        />
      </Stack>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 200,
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem 
          onClick={() => handleLanguageChange('en-US')}
        >
          English
        </MenuItem>
        <MenuItem 
          onClick={() => handleLanguageChange('es')}
        >
          Español
        </MenuItem>
      </Menu>
    </Stack>
  )
}

export default LanguageSelector
